import React, { Component } from "react";
import amazon from "../logos/amazon.jpg";
import { Link } from "react-router-dom";
function Help() {
  const [state, setState] = React.useState({ submitted: false, counter: 0 });
  const [userName, setUserName] = React.useState("");
  const handleSubmit = (e) => {
    e.preventDefault();
    setState({ submitted: true, counter: state.counter + 1 });
  };
  if (state.submitted && state.counter === 1) {
    return (
      <div className="help-form-message">
        <h3 className="form-message">
          Thanks For Submitting your Feedback {userName.toUpperCase()}. We Will
          Reach You in a moment:
        </h3>
        <Link className="btn btn-link" to="/products">
          Shop here
        </Link>
      </div>
    );
  }
  return (
    <div className="signup-page login-page help help-page">
      <img src={amazon} alt="" className="amazon-logo" />
      <div className="signup-form">
        <form onSubmit={handleSubmit}>
          <label htmlFor="name">Name</label>
          <input
            type="text"
            className="input-field"
            name="name"
            required
            value={state.userName}
            id="name"
            onChange={(e) => setUserName(e.target.value)}
          />
          <label htmlFor="email">Email</label>
          <input type="email" id="email" required className="input-field" />
          <label htmlFor="query">Enter Your Query Here:</label>
          <textarea
            name="query"
            id="query"
            cols="40"
            rows="10"
            className="input-field"
            required
          ></textarea>
          <button className="btn btn-continue">Submit</button>
        </form>
      </div>
    </div>
  );
}

export default Help;
